import React from "react";
import useStyled from "../../hooks/useStyled";
import PropTypes from "prop-types";

import { ListItem, ListItemButton } from "@mui/material";

import SFCheckbox from "../checkbox";

const { styled } = useStyled();

const ListItemStyled = styled(ListItem)(({ theme }) => ({
  margin: 0,
  "& .text": {
    color: theme.palette.grey300.main,
    "&.highlighted": {
      color: theme.palette.white.main,
    },
  },
}));

const ListItemButtonStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
  backgroundColor: selected ? theme.palette.grey450.main : theme.palette.grey450.main,
  "&:hover": {
    backgroundColor: "#3F3F4F",
  },
  // This is to make the list item row shorter
  " .MuiCheckbox-root": {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const GenericSearchOption = ({
  value,
  hasCheckbox,
  selected,
  onSelect,
  inputValue,
}) => {
  // Splits each option at the search input to that we can highlight
  // the part that matches that input
  const parts = value.split(new RegExp("(" + inputValue + ")", "gi"));

  return (
    <ListItemStyled key={value} disablePadding>
      <ListItemButtonStyled
        disableRipple
        selected={selected}
        onClick={onSelect}
      >
        {hasCheckbox && <SFCheckbox checked={selected} />}
        {/* Iterates through the parts and adds the class "highlighted" if the part matches the search input */}
        <div>
          {parts.map((part, idx) => (
            <span
              key={idx}
              className={`text ${
                part.toLowerCase() === inputValue.toLowerCase()
                  ? "highlighted"
                  : ""
              }`}
            >
              {part}
            </span>
          ))}
        </div>
      </ListItemButtonStyled>
    </ListItemStyled>
  );
};

GenericSearchOption.defaultProps = {
  hasCheckbox: false,
  selected: false,
  onSelect: null,
  inputValue: "",
};

GenericSearchOption.propTypes = {
  // The value that is displayed
  value: PropTypes.string.isRequired,
  // Whether each option has a checkbox
  hasCheckbox: PropTypes.bool,
  // Whether the checkbox is selected
  selected: PropTypes.bool,
  // A function that gets called when an option is clicked
  onSelect: PropTypes.func,
  // The value of the search input
  inputValue: PropTypes.string,
};

export default GenericSearchOption;
